import { render, staticRenderFns } from "./ConsignmentModalComponent.vue?vue&type=template&id=5f62d06c&"
import script from "./ConsignmentModalComponent.vue?vue&type=script&lang=js&"
export * from "./ConsignmentModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports